<script>
    import { publicRoles } from "../../utils/NotificationStrings";
    import { TokenStore } from "../../stores/TokenStore";

    export let content = {};

    $: targetUserName =
        $TokenStore?.user?.id === content.targetUser.id
            ? "you"
            : content.targetUser.name;
</script>

<p class="text-sm">
    <b>{content.user.name}</b>

    {#if content.action === "DELETE"}
        {#if content.user.id === content.targetUser.id}
            left topic
        {:else}
            removed

            {targetUserName}

            from topic
        {/if}
    {:else}
        set

        {targetUserName}

        as {publicRoles[content.role]}
    {/if}
</p>

<p class="parent-entity">
    {content.topicName}
</p>

<style>
    .parent-entity {
        @apply text-xs text-gray-400;
    }
</style>
